<template>
  <div class="oauth-close-container">
    <div class="oauth-close-title">{{ $t('oauthCloseView.title') }}</div>
    <div class="oauth-close-hint">{{ $t('oauthCloseView.hint') }}</div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'OauthCloseView',
    mounted() {
      setTimeout(() => {
        window.close();
      }, 50);
    },
  });
</script>

<style scoped lang="scss">
  .oauth-close-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 24px;
    text-align: center;
  }

  .oauth-close-title {
    font-size: 18px;
    font-weight: 600;
  }

  .oauth-close-hint {
    font-size: 14px;
  }
</style>
